var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StrictMode } from "react";
import { ChatbotServiceProvider } from "./components/ChatbotService/ChatbotServiceProvider";
import Page from "./Page";
import InstallLiveagent from "./components/SalesforceChatService/InstallLiveagent";
import { applyTheme } from "./applyTheme";
import shouldBeDeployedForUserSession from "./phasedDeployment";
var defaultUiLabels = {
    title: "Chat with us",
    introMessage: "Hello {name}, I'm a digital assistant. How can I help you?",
    buttonLabel: "Chat Now",
    sendButtonLabel: "Send",
    textAreaPlaceholder: "Type your message here...",
    preChatFormTitle: "Start a conversation",
    preChatButtonLabel: "Start Chat",
    continueChatButtonLabel: "Continue Chat",
    humanHandoffButtonLabel: "Transfer to human",
    errorHandoffButtonLabel: "Transfer to human",
    errorTryAgainButtonLabel: "Try again",
};
function App(props) {
    var _a, _b, _c, _d;
    var width = (_a = props.width) !== null && _a !== void 0 ? _a : "320px";
    var height = (_b = props.height) !== null && _b !== void 0 ? _b : "498px";
    var root = (_c = props.element) !== null && _c !== void 0 ? _c : document.body;
    applyTheme(root, props.theme);
    var shouldDeploy = shouldBeDeployedForUserSession(props.phasedDeploymentPercentage);
    var uiLabels = __assign(__assign({}, defaultUiLabels), props.uiLabels);
    if (!shouldDeploy) {
        console.log("Phased deployment: skipping chat client");
        return null;
    }
    return (_jsxs(ChatbotServiceProvider, { endpoint: props.chatbotEndpoint, token: props.token, children: [_jsx(StrictMode, { children: _jsx(Page, { width: width, height: height, departments: props.departments, uiLabels: uiLabels, assistantId: props.assistantId, gtag: props.gtag, isAuthenticated: !!props.token, firstName: props.firstName, lastName: props.lastName, email: props.email, threadTimeout: (_d = props.threadTimeout) !== null && _d !== void 0 ? _d : 24 * 60 * 60 * 1000 }) }), _jsx(InstallLiveagent, { options: props.salesforceChatOptions, width: width, height: height })] }));
}
export default App;
